import { Component, HostBinding, Input } from '@angular/core';

import { ScheduleModel } from '../../../../../../reducers/orm/schedule/schedule.model';

@Component({
  standalone: false,
  selector: 'timesheet-total-schedule',
  templateUrl: './timesheet-total-schedule.component.html',
})
export class TimesheetTotalScheduleComponent {
  @Input()
  schedule: ScheduleModel;
  @Input()
  employeeId: string;
  @Input()
  dayIsClosed: boolean;

  @HostBinding('style.height.px')
  height = 36;
}
